import {
  Organization,
  OrganizationCreationParams,
  OrganizationListParams,
  OrganizationUserCreationParams,
  OrganizationUserScopeCreationParams
} from '~core/models/organization.models';
import { CreateCustomerSupplierParams } from '~core/models/customer-supplier.model';
import { UserPreferences } from '~core/models/core.models';
import { UploadOrganizationLogoParams } from '~core/models/organization.models';
import { RequestParams } from '~core/models/core.models';

export class LoadOrganizations {
  static readonly type = '[Organization] Load Organizations';
  constructor(public params?: OrganizationListParams) {}
}

export class LoadOrganization {
  static readonly type = '[Organization] Load Organization';
  constructor(
    public organizationId: string,
    public params?: OrganizationListParams
  ) {}
}

export class CreateOrganization {
  static readonly type = '[Organization] Create Organization';
  constructor(public data: OrganizationCreationParams) {}
}

export class UpdateOrganization {
  static readonly type = '[Organization] Update Organization';
  constructor(
    public organizationId: string,
    public data: Partial<OrganizationCreationParams>
  ) {}
}

export class PatchOrganization {
  static readonly type = '[Organization] Patch Organization';
  constructor(
    public organizationId: string,
    public data: Partial<Organization>
  ) {}
}

export class DeleteOrganization {
  static readonly type = '[Organization] Delete Organization';
  constructor(public organizationId: string) {}
}

export class LoadOrganizationUsers {
  static readonly type = '[Organization] Load Organization Users';
  constructor(
    public userId: string,
    public params?: RequestParams
  ) {}
}

export class UpdateOrganizationUser {
  static readonly type = '[Organization] Update Organization User';
  constructor(
    public userId: string,
    public data: Partial<OrganizationUserCreationParams[]>
  ) {}
}

export class UpdateOrganizationUserScopes {
  static readonly type = '[Organization] Update Organization User Scopes';
  constructor(
    public organizationId: string,
    public userId: string,
    public data: OrganizationUserScopeCreationParams
  ) {}
}

export class DeleteOrganizationUser {
  static readonly type = '[Organization] Delete Organization User';
  constructor(
    public userId: string,
    public data: { scopes: { establishmentId: string; roleId: string }[] }
  ) {}
}

export class UploadOrganizationLogo {
  static readonly type = '[Organization] Upload Organization Logo';
  constructor(public data: UploadOrganizationLogoParams) {}
}

export class LoadPartners {
  static readonly type = '[Organization] Load Partners';
  constructor(
    public organizationId: string,
    public params?: RequestParams
  ) {}
}

export class CreatePartner {
  static readonly type = '[Organization] Create Partner';
  constructor(
    public organizationId: string,
    public data: CreateCustomerSupplierParams
  ) {}
}

export class AddPartnerInOrganization {
  static readonly type = '[Organization] Add Partner In Organization';
  constructor(
    public organizationId: string,
    public partnerId: string
  ) {}
}

export class PublicSearchOrganization {
  static readonly type = '[Organization] Public Search Organization';
  constructor(
    public organizationReference: string,
    public ntd?: string
  ) {}
}

export class LoadOrganizationPreferences {
  static readonly type = '[Organization] Load Organization Preferences';
  constructor(public organizationId: string) {}
}

export class SetOrganizationPreferences {
  static readonly type = '[Organization] Set Organization Preferences';
  constructor(
    public organizationId: string,
    public preferences: Partial<UserPreferences>
  ) {}
}

export class ClearSelectedOrganization {
  static readonly type = '[Organization] Clear Selected';
}

export class ResetOrganizationState {
  static readonly type = '[Organization] Reset State';
}
